import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@elit-hair/elit-ui";
import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";
import { usePageFilters } from "@/providers/hooks/use-page-filters";
import { PageFilterSummaryItem } from "@/types/page-filters.types";

const EMPTY_FILTER_SUMMARY: PageFilterSummaryItem[] = [];

type PageFiltersDialogProps = {
    children: ReactNode;
    contentClassName?: string;
    summary?: PageFilterSummaryItem[];
};

export function PageFiltersDialog({
    children,
    contentClassName,
    summary = EMPTY_FILTER_SUMMARY,
}: PageFiltersDialogProps) {
    const { t } = useTranslation();
    const { registerPageFilters, unregisterPageFilters, filtersOpen, setFiltersOpen, setFilterSummary } =
        usePageFilters();

    useEffect(() => {
        registerPageFilters();
        return unregisterPageFilters;
    }, [registerPageFilters, unregisterPageFilters]);

    useEffect(() => {
        setFilterSummary(summary);
    }, [summary, setFilterSummary]);

    return (
        <Dialog open={filtersOpen} onOpenChange={setFiltersOpen}>
            <DialogContent className={cn("max-h-[min(90vh,48rem)] overflow-y-auto sm:max-w-lg", contentClassName)}>
                <DialogHeader>
                    <DialogTitle>{t("filters")}</DialogTitle>
                </DialogHeader>
                {children}
            </DialogContent>
        </Dialog>
    );
}
